import styled, { css } from 'styled-components';

import { ColumnBlock } from '../../../styled';

export const TableWrapper = styled.div<{ isScrollable: boolean }>`
  margin-left: -32px;
  margin-right: -32px;
  height: inherit;
  ${(props) => props.isScrollable && 'overflow: hidden'};
`;

export const TableHeadWrapper = styled.div`
  width: 100%;
  display: block;
`;

export const TableHeadRow = styled.div`
  display: flex;
  text-align: left;
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  border-top: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const HeadSeparator = styled.div`
  background: ${(props) => props.theme.colors.stroke};
  height: 12px;
  width: 1px;
  right: 12px;
  position: absolute;
`;

export const TableHeadItem = styled.div<{ width: number; separator: boolean }>`
  display: flex;
  align-items: center;
  position: relative;

  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.muted};

  height: 40px;
  width: ${(props) => props.width}%;
`;

export const TableHeadText = styled.p<{ padding: number }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - ${(props) => props.padding} * 20px);
`;

export const CellWrapper = styled(ColumnBlock)<{ width: number }>`
  width: ${(props) => props.width}%;
  ${(props) => props.theme.typography.caption};
  padding-right: 12px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const TableBodyWrapper = styled.div<{ isScrollable: boolean }>`
  width: 100%;
  display: block;
  height: calc(100% - 42px);
  ${(props) => props.isScrollable && 'overflow-y: auto'};
`;

export const TableBodyRow = styled.div`
  display: flex;
  text-align: left;
  :nth-child(odd) {
    background-color: ${(props) => props.theme.colors.tableCell};
  }
`;

export const TableBodyItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 90px;
  overflow: hidden;
`;

export const ExtraBodyItem = styled(TableBodyItem)`
  background-color: white;
`;

export const SortElement = styled.div`
  cursor: pointer;
  margin-left: 4px;
  display: flex;
  align-items: center;
`;

const ActiveSortDirStyles = css`
  color: ${(props) => props.theme.colors.brand};
  transform: scale(1.2);
`;

export const ArrowsWrapper = styled.div<{ ascSort: boolean; activeStatus: boolean }>`
  position: relative;
  width: 20px;
  height: 20px;
  svg {
    position: absolute;
  }
  svg:first-child {
    top: -3px;
    ${(props) => props.activeStatus && props.ascSort && ActiveSortDirStyles};
  }
  svg:last-child {
    bottom: -3px;
    ${(props) => props.activeStatus && !props.ascSort && ActiveSortDirStyles};
  }
`;
